// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"edb01843","732":"c75cca81","977":"05c91ef0"}[chunkId] + ".chunk.js");